import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
// import parserFilters from '@/utils/parserFilters'
// import parserSlug from '@/utils/parserSlug'
import moment from 'moment'
const model = (payload) => ({
  // columns
  id: payload.id
})
var crud = new Crud('SubmittalDetails', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  submittalDetails: [],
  submittal: []
}

const mutations = {
  ...crud.mutations,
  SET_SUBMITTAL (state, payload) {
    state.submittal = payload.data
  }
}

const actions = {
  ...crud.actions,
  async loadSubmittal ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`submittals/${payload.idsubmittal}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_SUBMITTAL', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addSubmittalDetail ({ commit }, payload) {
    let formData = new FormData()
    formData.append('importFile', payload.file)
    formData.append('date', moment(payload.newRecord.date).format('YYYY-MM-DD'))
    formData.append('submittal_id', payload.submittal_id)
    formData.append('creator', payload.newRecord.creator)
    formData.append('comments', payload.newRecord.comments)

    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`submittals/${payload.submittal_id}/details`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.submittals', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_SUBMITTAL', response)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.submittals', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async deleteSubmittalDetail ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`submittal-details/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  setModalVisible ({ commit }, payload) {
    commit('SET_MODAL_VISIBLE', payload)
  }
}

const getters = {
  ...crud.getters,
  submittal: state => state.submittal,
  submittalDetails: state => state.submittalDetails
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
